import React from 'react';
import "../../styles/realTime/realTime.scss";

function noRecords(props) {
    return (
        <div className="real-empty-state">
            <div className="empty-icon">
                <i className="fa fa-map-marker"></i>
            </div>
            <div>
                <h2>No assets assigned</h2>
                <p>
                    {props.groupName
                        ? `There are currently no assets assigned to ${props.groupName}.`
                        : "There are currently no assets assigned to this group."}
                </p>
                <div className="empty-meta">
                    <span>Choose another group from the picker above</span>
                </div>
            </div>
        </div>
    );
}

export default noRecords;
